import React from 'react'
import DefaultLayout from '../components/DefaultLayout'
import egg from "../assets/eggroll.png"
import rora from "../assets/roraMain.png"
import ot from "../assets/OTLogo.png"
import cld from "../assets/cloudy.png"
import UT from "../assets/utATX.png"
import reel from "../assets/reel.png"
import stop from "../assets/stop-sign.png"
import SM from "../assets/stock-market.png"
import NS from "../assets/NS_mini_Logo_dark.png"
import pdf from "../assets/docs/Performance.20261003.125421.pdf"
import { Button } from 'antd'
import { Link } from 'react-router-dom'
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';
import { EffectCoverflow, Pagination } from 'swiper/modules';

function Work() {

  return (
    <DefaultLayout>
      <div className='container pt-3'>
        <h1>Projects</h1>
        <div className='pt-4'>
          <div className='mb-4'>
            <h4>AI Models</h4>
            <Swiper
              effect={'coverflow'}
              grabCursor={true}
              centeredSlides={true}
              slidesPerView={'auto'}
              coverflowEffect={{
                rotate: 50,
                stretch: 0,
                depth: 100,
                modifier: 1,
                slideShadows: false,
              }}
              pagination={true}
              modules={[EffectCoverflow, Pagination]}
              className="mySwiper AI"
            >
              <SwiperSlide>
                <div className='bxs p-3'>
                  <img className='pt-2 pb-2' src={SM} width="150" />
                  <h3>S&P 500 Futures</h3>
                  <p>LLM Trading Signal with Paper Money</p>
                  <Button style={{ backgroundColor: "dodgerblue", color: "whitesmoke" }} href={pdf} target="_blank">Results</Button>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className='bxs p-3'>
                  <img className='pt-2 pb-2' src={stop} width="150" />
                  <h3>Stop Sign Detection</h3>
                  <p>Image Detection/Classification Project</p>
                  <Button style={{ backgroundColor: "dodgerblue", color: "whitesmoke" }} href="https://stop-sign-detection-668d55c5fee0a9331ea4f2bc.1j42icg2gad3.eu-gb.codeengine.appdomain.cloud" target="_blank">View</Button>
                </div>
              </SwiperSlide>
            </Swiper>
          </div>
          <div className='mb-5'>
            <h4>Design &amp; Development</h4>
            <Swiper
              effect={'coverflow'}
              grabCursor={true}
              centeredSlides={true}
              slidesPerView={'auto'}
              coverflowEffect={{
                rotate: 50,
                stretch: 0,
                depth: 100,
                modifier: 1,
                slideShadows: false,
              }}
              pagination={true}
              modules={[EffectCoverflow, Pagination]}
              className="mySwiper"
            >
              <SwiperSlide>
                <div className='bxs p-3'>
                  <img className='pt-2 pb-2' src={NS} width="250" />
                  <h3>NeuroStudio</h3>
                  <p>Developmental studio for integrating AI voice agents and chatbots into websites annd applications.</p>
                  <Button style={{ backgroundColor: "dodgerblue", color: "whitesmoke" }} href="https://www.neurostudio.io/" target="_blank">Visit</Button>
                  <Button style={{ backgroundColor: "dodgerblue", color: "whitesmoke" }} href="http://demo.neurostudio.io/" target="_blank">Demo</Button>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className='bxs p-3'>
                  <img className='pt-2 pb-2' src={UT} width="250" />
                  <h3>UT Athletics</h3>
                  <p>2017-2018<br/>Univeristy of Texas sports teams website</p>
                  <Button style={{ backgroundColor: "dodgerblue", color: "whitesmoke" }} href="https://www.texassports.com/" target="_blank">Visit</Button>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className='bxs p-3 pb-3'>
                  <img className='pt-4 pb-3' src={rora} width="300" />
                  <h3 className='p-2'>Rora</h3>
                  <p className='p-2'>Vehicle Rental and Ride Share Web App</p>
                  <Button style={{ backgroundColor: "dodgerblue", color: "whitesmoke" }} href="http://roralive.s3-website-us-east-1.amazonaws.com" target="_blank">View</Button>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className='bxs p-3'>
                  <img className='pt-2 pb-2' src={reel} width="150" />
                  <h3>O'Cinema</h3>
                  <p>React Movie Search App</p>
                  <Button style={{ backgroundColor: "dodgerblue", color: "whitesmoke" }} href="http://odis-react-movie-app.s3-website.us-east-2.amazonaws.com" target="_blank">View</Button>
                  <Button style={{ backgroundColor: "dodgerblue", color: "whitesmoke" }} href="https://github.com/oreese95/React-Movie-Search" target="_blank">Github</Button>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className='bxs p-3'>
                  <img src={cld} width="170" />
                  <h3>Weather App</h3>
                  <p>2015<br/>Google's 90min Coding Challenge</p>
                  <Button style={{ backgroundColor: "dodgerblue", color: "whitesmoke" }} href="https://odis-react-weather-app.s3.amazonaws.com/index.html" target="_blank">View</Button>
                  <Button style={{ backgroundColor: "dodgerblue", color: "whitesmoke" }} href="https://github.com/oreese95/react-weather-app_2024" target="_blank">Github</Button>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className='bxs p-3'>
                  <img src={egg} width="250" />
                  <h3>Eggroll Express</h3>
                  <p>2016</p>
                  <Button style={{ backgroundColor: "dodgerblue", color: "whitesmoke" }} href="http://www.eggrollexpressaustin.com/" target="_blank">Visit</Button>
                </div>
              </SwiperSlide>
            </Swiper>
          </div>
          <div className='row'>
            <h4>UX Research</h4>
            <div className='col-lg-12 d-flex justify-content-center'>
              <div className='bxs p-3 onBig-2'>
                <img src={ot} width="200" />
                <h3>OpenTable</h3>
                <p>Case Study</p>
                <Link to='/casestudy'><Button style={{ backgroundColor: "dodgerblue", color: "whitesmoke" }}>View</Button></Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </DefaultLayout>
  )
}

export default Work